module.exports = __webpack_public_path__ + "static/img/ttr04.f63da28.png";